import styled from 'styled-components';
import {Link} from 'gatsby';

const Nav = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  width: 100vw;
  height: 5%;
  max-width: 100%;
  font-family: Rockwell, serif;
  background-color: white;
  display: flex;
  align-items: center;
  align-content: center;
  padding-top: 24px;
  padding-bottom: 24px;
`;

const Header = styled.div`
  @media (max-width: 1030px) {
    width: 90%;
    max-width: 90%;
  }
  position: relative;
  width: 1200px;
  max-width: 100%;
  display: flex; 
  flex-direction: row;
  align-items: center; 
  align-content: center; 
  justify-content: space-between;
  margin-right: auto; 
  margin-left: auto;
`;

const Logo = styled(Link)`
  font-family: "Rockwell", serif;
  text-decoration: none;
  color: black;
  font-size: 1.4rem;
  transition: 0.3s ease-in-out;
  :hover {
    opacity: 0.7;
  }
`;

export {
    Nav,
    Logo,
    Header
};

